export default "__VITE_ASSET__x3QaF3aK__"